module.exports = __webpack_public_path__ + "static/assets/bd2d7b2437946f1add631d2a55997b2f.gif";